import { Config } from '../config';
import { ModelOption } from '../interfaces';
import { HttpService } from './http.service';

export abstract class ModelRegistryService {
  public static getModels = (fleetId: number, kind?: string): Promise<ModelOption[]> => {
    const params = new URLSearchParams({ fleet_id: fleetId.toString() });
    
    if (kind) {
      params.append('kind', kind);
    }

    return HttpService.fetchAuthorized(`${Config.APIv2}/model_registry/models?${params}`).then(
      (res: ModelOption[]) => res || [],
    );
  };
}
